import { MAX_PRODUCTS, QUERY_SEPARATOR } from './constants';
export function isComparisonEmpty(props) {
    return !props.defaultStartYear;
}
export const getTransformOnMove = (left, leftMax, isRightToLeft) => {
    if (left > 0 && !isRightToLeft) {
        return 0;
    }
    if (left < 0 && isRightToLeft) {
        return 0;
    }
    if (Math.abs(left) > leftMax) {
        return isRightToLeft ? leftMax : -leftMax;
    }
    return left;
};
export const buildUrl = (apiUrl, query) => {
    if (!query) {
        return apiUrl;
    }
    const productsId = query.split(QUERY_SEPARATOR).slice(0, MAX_PRODUCTS).join(QUERY_SEPARATOR);
    return `${apiUrl}${encodeURIComponent(productsId)}`;
};
export const getRowArray = (value, length, index) => {
    const rowArray = new Array(length).fill(null);
    rowArray[index] = value;
    return rowArray;
};
export const mergeSpecificationData = (data) => {
    const dataLength = data.length;
    const firstDataIndexWithTables = data.findIndex((item) => item.length > 0);
    if (firstDataIndexWithTables === -1) {
        return [];
    }
    const startingIndex = firstDataIndexWithTables + 1;
    const mergedData = data[firstDataIndexWithTables].map((table) => ({
        ...table,
        rows: table.rows.map((row) => ({
            ...row,
            value: getRowArray(row.value, dataLength, firstDataIndexWithTables),
        })),
    }));
    data.slice(startingIndex).forEach((item, index) => {
        const itemIndex = startingIndex + index;
        item.forEach((table) => {
            const tableIndex = mergedData.findIndex((mergedTable) => mergedTable.tabTitle === table.tabTitle);
            if (tableIndex === -1) {
                const mergedTable = {
                    ...table,
                    rows: table.rows.map((row) => ({
                        ...row,
                        value: getRowArray(row.value, dataLength, itemIndex),
                    })),
                };
                mergedData.push(mergedTable);
            }
            else {
                table.rows?.forEach((row) => {
                    const rowIndex = mergedData[tableIndex].rows?.findIndex((mergedRow) => mergedRow.key === row.key);
                    if (rowIndex === -1) {
                        const updatedRow = {
                            ...row,
                            value: getRowArray(row.value, dataLength, itemIndex),
                        };
                        mergedData[tableIndex].rows.push(updatedRow);
                    }
                    else {
                        mergedData[tableIndex].rows[rowIndex].value[itemIndex] = row.value;
                    }
                });
            }
        });
    });
    return mergedData.filter((table) => table.rows.some((row) => row.value.some(Boolean)));
};
